import { clampsText } from '@shared/utils/style/text';
import { styled, TextV2 } from '@withjoy/joykit';

export const StyledText = styled(TextV2)<{ clampAt: number | undefined; wordBreak?: string }>`
  word-break: ${({ wordBreak }) => (wordBreak ? wordBreak : 'break-all')};
  ${({ clampAt }) => clampAt && clampsText(clampAt)};
`;
